import { LoadableAfterPaint } from '@confluence/loadable';

import type { GlobalAppShortcutsSectionProps } from './GlobalAppShortcutsSection.tsx';

export const GlobalAppShortcutsSectionLoader = LoadableAfterPaint<GlobalAppShortcutsSectionProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalAppShortcutsSection" */ './GlobalAppShortcutsSection.tsx'
			)
		).GlobalAppShortcutsSection,
});
